import { http } from "@/http";
class ThingService {
  async updateUserId(baseStationId,userId) {
    return await http.put(`/things/updateUserId/${baseStationId}/${userId}`);
  }
  async getConfig() {
    return await http.get(`/config`);
  }
  async getThingFiltered(imei) {
      return http.get(`things/pages/filter`, {
        params: {
          pageNo: 1,
          pageSize: 1,
          sortBy: 'id',
          search: imei,
        },
      });
    } 

}
export default new ThingService();
